import { useEffect } from 'react';
import { track } from '@spotify-internal/track-js';

const isDev = env => env !== 'production';

export const setUpTrackJs = () => {
  if (isDev(process.env.NODE_ENV)) return;

  track({
    dataLayerPushInitial: true,
    googleTagManagerId: 'GTM-NFX358T',
    market: 'US',
    oneTrust: true,
    oneTrustDomainScript: '50da44be-0564-43df-b139-329aedcf267b',
  });
};

export const useTrackingConsent = () => {
  useEffect(() => {
    setUpTrackJs();
  }, []);
};
